export default {
    "library": {
        "folders_header": "Папки KPI",
        "add_folder_button": "Добавить папку",
        "add_subfolder_button": "Добавить папку",
        "folder_create_dialog_title": "Создание папки",
        "folder_edit_dialog_title": "Редактирование папки",
        "folder_edit_dialog_name_input_label": "Название папки",
        "delete_folder_button": "Удалить папку",
        "delete_folder_confirm_title": "Вы уверены, что хотите удалить папку?",
        "duplicate_folder_button": "Клонировать папку",
        "duplicate_folder_confirm_title": "Вы уверены, что хотите клонировать папку?",
        "add_element_button": "Добавить KPI в папку",
        "elements_empty_text": "В папке нет KPI",
        "element_edit_form_title_of_create": "Создание KPI",
        "element_edit_form_title_of_edit": "Редактирование KPI",
        "element_edit_form_name": "Наименование KPI",
        "element_edit_form_desc": "Описание KPI",
        "element_add_from_library_dialog_title": "Выбор KPI",
        "elements_header": "KPI",
        "elements_search_placeholder": "Поиск по названию KPI",
        "element_edit_form_scale_label": "Тип шкалы",
        "element_edit_form_scale_select_placeholder": "Выберите тип шкалы",
        "delete_element_used_notification": "Данный KPI используется в $related_card_elements_count KPI карт. Вы действительно хотите удалить ее? Эти KPI в картах будут удалены"
    },
    "cards": {
        "add_cards_button": "Создать карты",
        "card_restored_message": "Карта KPI успешно восстановлена",
        "add_cards_modal_queued_notify_title": "Создание карт запущено в фоне",
        "add_cards_modal_queued_notify_message": "По завершении придёт уведомление"
    },
    "card": {
        "section_add_element_button": "Добавить KPI",
        "section_element_name_column_placeholder": "Внесите название KPI",
        "section_element_desc_column_placeholder": "Вы можете добавить описание KPI, если необходимо",
        "comment_send_button_text": "Сохранить комментарий к карте"
    },
    "user": {
        "users_search_input_placeholder": "Поиск по ФИО, должности, email и перс.номеру",
        "chiefs_search_input_placeholder": "Поиск по ФИО, должности, БН и ФИО руководителя"
    },
    "common": {
        "user_no_role_overlay_text": "Отсутствуют права доступа в Систему целеполагания"
    },
    "evaluation": {
        "created_button": "Запустить этап формирования участников",
        "created_title": "После запуска этого этапа вы не сможете править основные настройки оценки, все равно запустить?",
        "recruitment_members_button": "Запустить оценку",
        "recruitment_members_title": "Вы действительно хотите запустить оценку?",
        "started_button": "Завершить оценку",
        "started_title": "Вы действительно хотите завершить оценку?",
        "finished_button": "Возобновить этап оценки",
        "finished_title": "Вы действительно хотите возобновить этап оценки?"
    }
}